<template>
  <div id="editMainDateList">
    <div class="allSearch">
      <div class="newSearch ">
        <div>
          <p class="font16" v-if="groupMainData.id === 0">新建分组</p>
          <p class="font16" v-else>编辑分组</p>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <nav class="m_l_10"><i class="VioletDot"></i><abbr class="font16">分组信息</abbr></nav>
      <ul class="allUL">
<!--        <li><i class="colorRed">*</i> <span>分组类型：</span>-->
<!--          <input :disabled="groupMainData.id !== 0" v-model="groupMainData.groupType" type="radio" value="Static" class="allRadio" id="radio1" name="choosegroupType"/>-->
<!--          <label for="radio1"></label><abbr>静态</abbr>-->
<!--          <input :disabled="groupMainData.id !== 0" v-model="groupMainData.groupType" type="radio" value="Dynamic" class="allRadio" id="radio2" name="choosegroupType"/>-->
<!--          <label for="radio2"></label><abbr>动态</abbr>-->
<!--        </li>-->
        <li><i class="colorRed">*</i> <span>分组名称：</span><input :disabled="onlyGroupOwner || (groupMainData.id !== 0 && type === 'Default')" v-model="groupMainData.name" type="text" class="allInput" style="width: 50%"/></li>
        <li>&nbsp;&nbsp;&nbsp;<span>描述：</span><input :disabled="onlyGroupOwner || (groupMainData.id !== 0 && type === 'Default')"  v-model="groupMainData.description" type="text" class="allInput" style="width: 50%;"/></li>
<!--        <li>-->
<!--          <i class="colorRed">*</i> <span>组管理员:</span><div class="allGroup">-->
<!--            <span :key="index" v-for="(item, index) in groupMainData.adminList"><abbr class="m_r_5">{{item.name}}</abbr><abbr @click="removeGroupUser(index)"  v-if="!onlyGroupOwner" class="colorCH c_p">×</abbr></span>-->
<!--          </div>-->
<!--          <button v-if="!onlyGroupOwner" class="redButtonTwo" @click="addMemberUser(1)">添加</button>-->
<!--        </li>-->

        <div class="w20 split_2" style="margin-bottom: 10px">
          <div :class="isHCP ? 'messagePushTabActive' : ''" @click="switchHCP(1)" class="p_t_b_5 b_t_r_10 border_dede t_c" style="font-size: 14px;">HCP</div>
          <div :class="isHCP ? '' : 'messagePushTabActive'" @click="switchHCP(0)" class="p_t_b_5 b_t_r_10 border_dede t_c" style="font-size: 14px;margin-left: -15px;border-left: none;">员工</div>
        </div>
        <li v-if="groupMainData.id !== 0 && isHCP">&nbsp;&nbsp;&nbsp;<span>分组成员：</span><div class="d_i" style="width: calc(100% - 120px);vertical-align: top">
          <!--静态-->
          <div style="align-items: flex-end" class="d_flex m_b_10">
            <div class="navP">
              <div>
                <p>
                  <input @keyup.enter="getGroupUserList(1)" class="allInput" type="text" placeholder="姓名/微信号" v-model="groupUserPostData.UserName">
                </p>
                <p>
                  <input @keyup.enter="getGroupUserList(1)" class="allInput" type="text" placeholder="所在地" v-model="groupUserPostData.City">
                </p>
              </div>
              <div style="margin-top: 10px">
                <p>
                  <input @keyup.enter="getGroupUserList(1)" class="allInput" type="text" placeholder="科室" v-model="groupUserPostData.Dept">
                </p>
                <p>
                  <input @keyup.enter="getGroupUserList(1)" class="allInput" type="text" placeholder="医院" v-model="groupUserPostData.Inst">
                </p>
                <p>
                  <button @click="getGroupUserList(1)" class="redButton">
                    搜索
                  </button>
                </p>
              </div>
            </div>
            <div>
              <button :disabled="parseInt(groupMainData.id) === 0" class="redButton" @click="addMemberUser(2)">添加</button>
            </div>
          </div>
          <table cellspacing="0" class="allTable">
            <thead>
            <tr>
              <th>姓名/微信号</th>
              <th>所在地</th>
              <th>科室</th>
              <th>医院</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr :key="index" v-for="(item, index) in groupUserList">
              <td>{{item.docName}}</td>
              <td>{{item.city}}</td>
              <td>{{item.department}}</td>
              <td>{{item.instName}}</td>
              <td><i class="icon iconfont iconzhengfangxingjian colorCH" @click="deltGrouplist(item)"></i></td>
            </tr>
            </tbody>
          </table>
        </div>
          <page v-if="UsertotalPage !== 0" :totalCount="UsertotalCount" v-on:on-getList="getGroupUserList($event)" :totalPage="UsertotalPage" :page="Userpage" :explain="0"></page>
        </li>
        <li v-if="groupMainData.id !== 0 && !isHCP">&nbsp;&nbsp;&nbsp;<span>分组员工</span>
          <div class="d_i" style="width: calc(100% - 120px);vertical-align: top">
            <div style="align-items: flex-end" class="d_flex m_b_10">
              <div class="navP">
                <div>
                  <p>
                    <input @keyup.enter="getEmployeeList(1)" class="allInput" type="text" placeholder="姓名" v-model="groupEmployeePostData.Name">
                  </p>
                  <p>
                    <input @keyup.enter="getEmployeeList(1)" class="allInput" type="text" placeholder="邮箱" v-model="groupEmployeePostData.Email">
                  </p>
                </div>
                <div style="margin-top: 10px">
                  <p>
                    <!-- <input @keyup.enter="getEmployeeist(1)" class="allInput" type="text" placeholder="部门" v-model="groupEmployeePostData.Department"> -->
                    <newSelect :borderLine="'#e1e1e1'" :showSearch="true" class="d_in v_m" :chooseData="departmentList" :needReturn="'department'" :placeholder="'请选择部门'" :matchValue="'name'" :showValue="'{{name}}'" v-model="groupEmployeePostData.Department">
                    </newSelect>
                  </p>
                  <p>
                    <button @click="getEmployeeList(1)" class="redButton">
                      搜索
                    </button>
                  </p>
                </div>
              </div>
              <div>
                <button :disabled="parseInt(groupMainData.id) === 0" class="redButton" @click="addMemberEmployee(2)">添加</button>
              </div>
            </div>
            <table cellspacing="0" class="allTable">
            <thead>
            <tr>
              <th>姓名</th>
              <th>邮箱</th>
              <th>部门</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr :key="index" v-for="(item, index) in groupUserList">
              <td width="20%">{{item.name}}</td>
              <td width="30%">{{item.email}}</td>
              <td :title="item.department" class="NoWrap">{{item.department}}</td>
              <td><i class="icon iconfont iconzhengfangxingjian colorCH" @click="deltGrouplist(item)"></i></td>
            </tr>
            </tbody>
          </table>
          </div>
          <page v-if="UsertotalPage !== 0" :totalCount="UsertotalCount" v-on:on-getList="getEmployeeList($event)" :totalPage="UsertotalPage" :page="Userpage" :explain="0"></page>
          
        </li>

      </ul>
      <div class="t_r">
        <button @click="saveGroups" class="redButtonTwo">保存</button>
        <button class="cancelButtonTwo" @click="allReturn">返回</button>
      </div>
    </div>
    <div v-if="groupMainData.groupType === 'Dynamic' && groupMainData.id !== 0" class="allTablePlace">
      <nav class="m_l_10"><i class="VioletDot"></i><abbr class="font16">规则集设置</abbr></nav>
      <div class="t_r m_b_10"><button @click="addnewRoles" class="redButtonTwo">新增规则集</button></div>
      <table cellspacing="0" class="allTable">
        <thead>
        <tr>
          <th>规则名称</th>
          <th>备注</th>
          <th class="t_c">用户数</th>
          <th>创建时间</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in dominlist" :key="index">
          <td>{{item.name}}</td>
          <td class="NoWrap" style="max-width: 200px;padding-right: 10px" width="25%">{{item.description}}</td>
          <td v-if="item.memberCount > 0" @click="getDominList(1, item)" class="t_c"><span class="colorBlue c_p" style="text-decoration: underline">{{item.memberCount}}</span></td>
          <td v-else class="t_c"><span>{{item.memberCount}}</span></td>
          <td>{{item.creationTime}}</td>
          <td><div class="icon more iconfont icongengduo moreOperations">
            <ul>
              <li @click="editDomin(item)">编辑</li>
              <li v-if="item.memberCount > 0" @click="getDominList(1, item)">查看用户</li>
              <li @click="deleteDomin(item.id)">删除</li>
            </ul>
          </div></td>
        </tr>
        </tbody>
      </table>
      <page v-if="domaintotalPage !== 0" v-on:on-getList="getList($event)" :totalCount="domaintotalCount" :totalPage="domaintotalPage" :page="domainPage" :explain="2"></page>
    </div>
    <!--新增规则集-->
    <userPicker :pickerModel="newpickerModel" :title="title" v-on:choosedConfirm="confirUserPicker($event)" v-model="showUserPicker" :groupId="groupMainData.id"></userPicker>
    <userPicker :pickerModel="'employeeDepartment'" :title="title" v-on:choosedConfirm="confirUserPicker($event)" v-model="showEmployeePicker"></userPicker>
    <model v-if="editDomainModel" :buttonType="0" :title="'规则集'" :minWidth="'800px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="DominConfirm()">
      <div class="allSearch">
        <ul class="allUL t_c">
          <li><span class="t_r m_r_10"><i class="colorRed m_r_5">*</i>规则名称</span><input type="text" v-model="DomainDto.name" class="allInput" style="width: 70%"/></li>
          <li><span class="t_r m_r_10">备注</span><input v-model="DomainDto.description" type="text" class="allInput" style="width: 70%;"/></li>
        </ul>
        <div style="max-height: 400px;overflow: auto;">
          <table cellspacing="0" class="allTable alltableHui">
            <thead>
            <tr>
              <th>Column</th>
              <th>Condition</th>
              <th>Value</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="item.modifyStatus !== -1" :key="index" v-for="(item, index) in DomainDto.groupDynamics">
              <td>
                <select @change="changeDominFlag(item)" class="allSelect" v-model="item.field">
                  <option  style="display: none" :value="''" selected>请选择</option>
                  <option :key="index" v-for="(childrenitem, index) in allfields" :value="childrenitem.id" selected>{{childrenitem.name}}</option>
                </select>
              </td>
              <td>
                <select @change="changeDominFlag(item)" class="allSelect" v-model="item.operation">
                  <option style="display: none" :value="''" selected>请选择</option>
                  <option v-if="(item.field === 100 && (childrenitem.id === 1 || childrenitem.id === 2 )) || item.field !== 100" :key="index" v-for="(childrenitem, index) in allOperationsList" :value="childrenitem.id" selected>{{childrenitem.name}}</option>
                </select>
              </td>
              <td>
                <select @change="changeDominFlag(item)" v-if="item.field === 100" class="allSelect" v-model="item.value">
                  <option value="-1">未知</option>
                  <option value="0">男</option>
                  <option value="1">女</option>
                </select>
                <input v-else @change="changeDominFlag(item)" v-model="item.value" type="text" class="allInput"/>
              </td>
              <td><i v-if="count" @click="reduceDomin(item, index)" class="icon iconfont iconzhengfangxingjian colorCH m_r_10"></i><i @click="addDomin" class="icon iconfont iconzhengfangxingjia colorCH"></i></td>
            </tr>
            </tbody>
          </table>
        </div>
        <p class="colorZh m_t_10">*规则之间是“并且”的关系</p>
      </div>
    </model>
    <model v-if="dominUserModel" :buttonType="1" :title="'查看用户'" :minWidth="'800px'" v-on:on-cancel="cancelModel()">
      <table cellspacing="0" class="allTable alltableHui">
        <thead>
        <tr style="background-color: #FBFBFB;color: #797979">
          <th>姓名</th>
          <th class="t_c">性别</th>
          <th>工作邮箱</th>
          <th>分公司</th>
          <th>所在地</th>
          <th>地址</th>
          <th>部门</th>
          <th>已关注</th>
        </tr>
        </thead>
        <tbody>
        <tr :key="index" v-for="(item, index) in dominUserList">
          <td width="5%" class="NoWrap" style="max-width: 30px" :title="item.name">{{item.name}}</td>
          <td width="5%" class="t_c NoWrap" :title="$commonJs.getGender(item.gender)">{{$commonJs.getGender(item.gender)}}</td>
          <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.email">{{item.email}}</td>
          <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.company_Name">{{item.company_Name}}</td>
          <td width="5%" class="NoWrap" style="max-width: 50px;" :title="item.location">{{item.location}}</td>
          <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.building_Long">{{item.building_Long}}</td>
          <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.org_Acronym">{{item.org_Acronym}}</td>
          <td width="5%">{{item.isAttention ? '已关注': '未关注'}}</td>
        </tr>
        </tbody>
      </table>
      <page v-if="dominUserList !== 0" v-on:on-getList="getDominList($event)" :totalCount="allPageDto.allDominListTotalCount" :totalPage="allPageDto.allDominListTotalPage" :page="allPageDto.allDominListPage" :explain="0"></page>
    </model>
  </div>
</template>

<script>
export default {
  name: 'editMainDateList',
  data () {
    return {
      isHCP: true,
      onlyGroupOwner: false,
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      type: this.$route.query.type,
      newpickerModel: '',
      dominUserModel: false,
      selectUserType: 1,
      showUserPicker: false,
      showEmployeePicker: false,
      groupMainData: {
        id: parseInt(this.$route.query.id),
        name: '',
        groupType: 'Static',
        // adminIds: [
        // ],
        // adminList: [],
        description: ''
        // groupType: 'default'
      },
      groupUserList: [],
      editUserModel: false,
      showModel: false,
      title: '',
      tabSwitch: 1,
      UsertotalPage: 0,
      UsertotalCount: 0,
      Userpage: 1,
      domainpage: 1,
      domaintotalPage: 0,
      domaintotalCount: 0,
      groupUserPostData: {
        title: '',
        UserName: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      groupEmployeePostData: {
        Name: '',
        Email: '',
        Department: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      DomainDto: {
        id: 0,
        name: '',
        description: '',
        groupDynamics: [
          {
            modifyStatus: -2,
            id: 0,
            operation: '',
            field: '',
            value: ''
          }
        ]
      },
      dominData: {
        pageIndex: 1,
        pageSize: this.$commonJs.commonPageSize
      },
      dominlist: [],
      editDomainModel: false,
      allOperationsList: [],
      allfields: [],
      dominUserList: [],
      allPageDto: {
        allDominListTotalPage: 0,
        allDominListTotalCount: 0,
        allDominListPage: 1
      },
      newDominList: {
        domninId: 0,
        pageIndex: 1,
        pageSize: this.$commonJs.commonPageSize
      },
      departmentList: []
    }
  },
  computed: {
    count () {
      let num = 0
      for (let i = 0; i < this.DomainDto.groupDynamics.length; i++) {
        if (this.DomainDto.groupDynamics[i].modifyStatus !== -1) {
          num++
        }
      }
      console.log(num)
      if (num > 1) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    // if (this.nowApp.roles.indexOf('AppOwner') < 0 && this.nowApp.roles.indexOf('GroupOwner') >= 0) {
    //   this.onlyGroupOwner = true
    //   console.log(this.onlyGroupOwner)
    // }
    if (parseInt(this.groupMainData.id) !== 0) {
      this.getGroupDetail()
      // this.getAppDomin(1)
    }
    // this.getAllfields()
    // this.getOperations()
    window.sessionStorage.setItem('needNotice', 'true')
    this.getEmployeeDepartment()
  },
  methods: {
    getEmployeeDepartment () {
      this.$axiox.get('/api/Group/GetAllEmployeeDepartment').then( p => {
        this.departmentList = [{
          name: '全部',
          department: ''
        }].concat(p || [])
      } )
    },
    switchHCP (value) {
      this.isHCP = value === 1
      if (value === 1) {
        // this.getList(1)
        this.getGroupUserList(1)
      } else {
        // this.getAll(1)
        this.getEmployeeList(1)
      }
    },
    getDominList (pageIndex, object) {
      if (object) {
        this.dominUserModel = true
        this.newDominList.domninId = object.id
      }
      this.allPageDto.allDominListPage = pageIndex
      this.newDominList.pageIndex = pageIndex
      this.$axiox.get('/api/Group/groupDomain/' + this.newDominList.domninId + '/Members?pageSize=' + this.newDominList.pageSize + '&pageIndex=' + this.newDominList.pageIndex).then(msg => {
        this.dominUserList = msg.result.items
        this.allPageDto.allDominListTotalPage = Math.ceil(msg.result.totalCount / this.newDominList.pageSize)
        this.allPageDto.allDominListTotalCount = msg.result.totalCount
      })
    },
    changeDominFlag (item) {
      if (item.id !== 0) {
        item['modifyStatus'] = 0
      }
    },
    // 删除domin
    deleteDomin (id) {
      this.$commonJs.doubleComfirm({
        content: '是否要删除规则集？',
        successFun: p => {
          this.$axiox.del('/api/Group/groupDomain?groupDomainId=' + id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getAppDomin(this.dominData.pageIndex)
          })
        },
        errorFun: msg => {
        }
      })
    },
    getOperations () {
      this.$axiox.getNomalData('/api/application/filterPolicy/operations').then(msg => {
        this.allOperationsList = msg
      })
    },
    addDomin () {
      const data = {
        modifyStatus: 1,
        id: 0,
        operation: '',
        field: '',
        value: ''
      }
      this.DomainDto.groupDynamics.push(data)
    },
    getAllfields () {
      this.$axiox.getNomalData('/api/application/filterPolicy/fields').then(msg => {
        this.allfields = msg
      })
    },
    reduceDomin (item, index) {
      if (item.id === 0) {
        this.DomainDto.groupDynamics.splice(index, 1)
      } else {
        this.$set(this.DomainDto.groupDynamics[index], 'modifyStatus', -1)
      }
    },
    // 获取app的规则集
    getAppDomin (pageIndex) {
      this.dominData.pageIndex = pageIndex
      const url = this.$commonJs.returnQuery('/api/Group/' + this.groupMainData.id + '/groupDomain', this.dominData)
      this.$axiox.get(url).then(msg => {
        this.domainPage = pageIndex
        this.dominlist = msg.result.items
        this.domaintotalPage = Math.ceil(msg.result.totalCount / this.dominData.pageSize)
        this.domaintotalCount = msg.result.totalCount
        console.log(this.domaintotalCount)
      })
    },
    // 编辑domin
    editDomin (item) {
      this.DomainDto = JSON.parse(JSON.stringify(item))
      console.log(this.DomainDto)
      this.editDomainModel = true
    },
    // 新建规则
    DominConfirm () {
      if (this.DomainDto.id === 0) {
        if (this.DomainDto.name !== '') {
          this.$axiox.post('/api/Group/' + this.groupMainData.id + '/groupDomain', this.DomainDto).then(msg => {
            this.editDomainModel = false
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '保存成功',
              stayTime: 5
            })
            this.getAppDomin(this.dominData.pageIndex)
          })
        }
      } else {
        if (this.DomainDto.name !== '') {
          let data = JSON.parse(JSON.stringify(this.DomainDto))
          for (let i = 0; i < data.groupDynamics.length; i++) {
            if (data.groupDynamics[i].modifyStatus === undefined) {
              data.groupDynamics.splice(i, 1)
              i--
            }
          }
          this.$axiox.put('/api/Group/groupDomain', data).then(msg => {
            this.editDomainModel = false
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '保存成功',
              stayTime: 5
            })
            this.getAppDomin(this.dominData.pageIndex)
          })
          console.log(data)
        }
      }
    },
    // 打开新增规则集
    addnewRoles () {
      this.DomainDto = {
        id: 0,
        name: '',
        description: '',
        groupDynamics: [
          {
            modifyStatus: 1,
            id: 0,
            operation: '',
            field: '',
            value: ''
          }
        ]
      }
      this.editDomainModel = true
    },
    // 添加组管理员
    addMemberUser (type) {
      this.selectUserType = type
      this.showUserPicker = true
      if (type === 1) {
        this.newpickerModel = 'groups'
        this.showModel = true
        this.title = '添加组管理员'
      } else {
        this.newpickerModel = 'groups'
        this.showModel = true
        this.title = '分组成员'
      }
    },
    addMemberEmployee(type){
      this.selectUserType = type
      this.showEmployeePicker = true
      this.title = '分组成员'
    },
    getGroupDetail () {
      this.$axiox.get('/api/Group/GetGroupById?id=' + this.groupMainData.id).then(msg => {
        this.groupMainData = msg
        // this.groupMainData.adminIds = []
        // for (let i = 0; i < this.groupMainData.adminList.length; i++) {
        //   this.groupMainData.adminIds.push(this.groupMainData.adminList[i].id)
        // }
        // this.$set(this.groupMainData, 'groupType', this.groupMainData.type)
        // this.groupMainData.groupType = this.groupMainData.type
        this.getGroupUserList(1)
      })
    },
    getGroupUserList (pageIndex) {
      this.groupUserPostData.PageIndex = pageIndex
      this.groupUserPostData.groupId = this.groupMainData.id
      let url = this.$commonJs.returnQuery('/api/Group/GetWechatUserByGroup', this.groupUserPostData)
      this.$axiox.getList(url).then(msg => {
        this.Userpage = pageIndex
        this.groupUserList = msg.data
        this.UsertotalPage = Math.ceil(msg.total / this.groupUserPostData.PageSize)
        this.UsertotalCount = msg.total
      })
    },
    getEmployeeList (pageIndex) {
      this.groupEmployeePostData.PageIndex = pageIndex
      this.groupEmployeePostData.GroupId = this.groupMainData.id
      debugger
      let url = this.$commonJs.returnQuery('/api/Group/GetAllGroupEmployees', this.groupEmployeePostData)
      this.$axiox.getList(url).then(msg => {
        this.Userpage = pageIndex
        this.groupUserList = msg.data
        this.UsertotalPage = Math.ceil(msg.total / this.groupUserPostData.PageSize)
        this.UsertotalCount = msg.total
      })
    },
    confirModel () {
    },
    cancelModel () {
      this.showModel = false
      this.editDomainModel = false
      this.dominUserModel = false
    },
    saveGroups () {
      if (this.groupMainData.name === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '提示',
          content: '请输入分组名称',
          stayTime: 5
        })
        return
      }
      // if (parseInt(this.groupMainData.id) === 0) {
      //   this.$axiox.post('/api/Group', this.groupMainData).then(msg => {
      //     this.groupMainData.id = msg.result
      //     this.$commonJs.alertTips({
      //       type: 'success',
      //       title: '成功',
      //       content: '新建组成功',
      //       stayTime: 5
      //     })
      //   })
      // } else {
      // if (this.type === 'Default') {
      //   console.log(this.groupMainData)
      //   this.$axiox.post('/api/Group?Create', this.groupMainData.adminIds).then(msg => {
      //     this.$commonJs.alertTips({
      //       type: 'success',
      //       title: '成功',
      //       content: '保存组成功',
      //       stayTime: 5
      //     })
      //   })
      // } else {
      //
      // }
      if (parseInt(this.groupMainData.id) === 0) {
        this.$axiox.post('/api/Group/Create', this.groupMainData).then(msg => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '保存组成功',
            stayTime: 5
          })
          this.groupMainData.id = msg.id
        })
      } else {
        this.$axiox.post('/api/Group/Update', this.groupMainData).then(msg => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '保存组成功',
            stayTime: 5
          })
        })
      }
      // }
      // }
    },
    // 删除静态组成员
    deltGrouplist (item) {
      this.$commonJs.doubleComfirm({
        content: '是否确定删除?',
        successFun: msg => {
          this.deltGrouplistOK(item)
        },
        errorFun: msg => {
        }
      })
    },
    deltGrouplistOK (item) {
      this.$axiox.post('/api/Group/RemoveWechatUsers?groupId=' + this.groupMainData.id, [item.openId]).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '删除成功',
          stayTime: 5
        })
          if (this.isHCP){
            this.getGroupUserList(this.groupUserPostData.PageIndex)
          } else {
            this.getEmployeeList(this.groupEmployeePostData.PageIndex)
          }
      })
    },
    // 返回上一页
    allReturn () {
      window.sessionStorage.setItem('needNotice', 'false')
      this.$router.go(-1)
    },
    removeGroupUser (index) {
      this.groupMainData.adminList.splice(index, 1)
      this.groupMainData.adminIds.splice(index, 1)
    },
    confirUserPicker (e) {
      debugger
      if (this.selectUserType === 1) {
        for (let i = 0; i < e.chooseUserList.length; i++) {
          let flag = true
          for (let j = 0; j < this.groupMainData.adminList.length; j++) {
            if (e.chooseUserList[i].id === this.groupMainData.adminList[j].id) {
              flag = false
            }
          }
          if (flag) {
            this.groupMainData.adminList.push(e.chooseUserList[i])
            this.groupMainData.adminIds.push(e.chooseUserList[i].id)
          }
        }
      }
      if (this.selectUserType === 2) {
        // e.chooseUserIdList
        setTimeout(p => {
          if (this.isHCP){
            this.getGroupUserList(1)
          } else {
            this.getEmployeeList(1)
          }
        }, 2000)
        this.$axiox.post('/api/Group/AddWechatUsers?groupId=' + this.groupMainData.id, e.chooseUserIdList).then(msg => {
          if (this.isHCP){
            this.getGroupUserList(1)
          } else {
            this.getEmployeeList(1)
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/mainDateManager/editMainDateList.vue